// @vendors
const Immutable = require('immutable');

// @helpers
const { cleanUpAccents } = require('utilities/stringHelper');

// @constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CHANGE_TRANSCRIPTION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CANCEL,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE_SUCCESS
} = require('constants/actionTypes');

const INITIAL_STATE = Immutable.fromJS({
    omitTestTrascriptionText: '',
    omitTestInvalidText: false,
    omitTestCanContinue: false
});

function validateContinue(immState, toTranscribe) {
    const transcription = cleanUpAccents(immState.get('omitTestTrascriptionText'));
    return immState.merge({
        omitTestInvalidText: cleanUpAccents(toTranscribe) !== transcription,
    });
}

function brokerConvenienceMiFIDTestStepOmitTest(state = INITIAL_STATE, action) {
    switch (action.type) {
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CHANGE_TRANSCRIPTION:
            return state.set('omitTestTrascriptionText', action.payload.transcription);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CANCEL:
            return state; // @hardcoded
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE:
            return validateContinue(state, action.payload.requiredText);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE_SUCCESS:
            return state.set('omitTestCanContinue', true);
        default:
            return state;
    }
}

module.exports = brokerConvenienceMiFIDTestStepOmitTest;
